import { useEffect } from 'react';
import { useDispatch, useStore } from 'react-redux';
import G from './Getters';
import A from './ActionCreators';
export default function useRequestResponse(route){

  const store = useStore();
  const dispatch = useDispatch();
  const state = store.getState();

  let response = G.getRequestResponse(state,{route})



  useEffect(() => {

    dispatch(A.makeRequest({
      route,
      body:{},
      onFailure:() => {},
    }))

  },[route])

  const rerequest = () => {
    dispatch(A.makeRequest({
      route,
      body:{}
    }))
  }






  return [ response, rerequest ];


}
